import React from 'react';

// Minimal placeholder bodies for legal/about. Replace copy as needed.

export const About: React.FC = () => (
  <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10 prose prose-sm">
    <h1>About Bleums Creations</h1>
    <p>Tell your story here.</p>
  </div>
);

export const Privacy: React.FC = () => (
  <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10 prose prose-sm">
    <h1>Privacy Policy</h1>
    <p>Add your privacy policy here.</p>
  </div>
);

export const Terms: React.FC = () => (
  <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10 prose prose-sm">
    <h1>Terms of Service</h1>
    <p>Add your terms here, including a clear non-refundable clause for
       personalized items once production has started.</p>
  </div>
);

export const NotFound: React.FC = () => (
  <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16 text-center">
    <h1 className="text-3xl font-semibold mb-2">Page not found</h1>
    <p className="text-text-light">
      The page you're looking for doesn't exist.
    </p>
  </div>
);
